<template>
    <div>
        <main class="authentication">
            <div class="authentication__content">
                <div class="authentication__form authentication__form--registration">
                    <h1 class="authentication__form-title">{{ trans('page.register.title') }}</h1>
                    <registration-form @submit="register">
                        <template v-slot:registration-button>
                            <nav class="u-text-right">
                                <button
                                    class="btn btn--auth button-nav-submit--ghost | u-padding-right-big"
                                    dusk="registration-button"
                                    type="submit"
                                >
                                    {{ trans('authentication.register.button') }}
                                </button>
                            </nav>
                        </template>
                    </registration-form>
                </div>
                <small>
                    <span
                        class="authentication__form-term-link"
                        v-html="trans('authentication.register.privacy-info', { url: this.privacyLink })"
                    />
                </small>
            </div>
        </main>
    </div>
</template>

<script>
import { apiMixin } from 'relapp-api';
import { RegistrationForm } from 'relapp-auth';
import { pageLoadingStatusMixin } from 'relapp-loading';
import { AuthApi } from 'relapp-auth';

export default {
    components: {
        RegistrationForm
    },
    mixins: [apiMixin, pageLoadingStatusMixin],

    props: {},
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        this.finishLoading();
        if (this.isLoggedIn) {
            this.$router.push({ name: 'orderFullDomain' });
        }
    },
    computed: {
        /**
         * Return the privacy link.
         *
         * @return {array}
         */
        privacyLink() {
            return process.env.VUE_APP_PRIVACY_LINK;
        }
    },
    methods: {
        /**
         * Submit registration form
         *
         * @param {object} form
         */
        register(form) {
            this.startLoading();
            AuthApi.register(form.data())
                .then(() => {
                    this.finishLoading();
                    this.$router.push({ name: 'registerConfirmation' });
                })
                .catch(error => {
                    this.showValidationErrors(error, form);
                })
                .then(this.finishLoading);
        }
    },
    metaInfo: {
        title: trans('page.register.title')
    }
};
</script>
